<template>
    <div class="productdetail">
        <div class="name">
            <div class="product_name">
                <span v-if="languageType == 0">{{dataFrom.name}}</span>
                <span v-else>{{dataFrom.enName}}</span>
            </div>
            <!-- <div class="product_links" @click="goTB(dataFrom.url)">
                <p v-if="languageType == 0">前往淘宝</p>
                <p v-else>To taobao</p>
                <div class="arrow">➜</div>
            </div> -->
        </div>
        <div class="detail">
            <div class="text" v-if="languageType == 0" v-html="dataFrom.introduce"></div>
            <div class="text" v-else v-html="dataFrom.enIntroduce"></div>
            <div class="whell">
                <div class="swiper-container gallery-top">
                    <div class="swiper-wrapper">
                        <!-- :style="{backgroundImage:'url('+item+')'}" -->
                        <div class="swiper-slide" v-for="(item,index) in dataFrom.picsArr" :key="index" >
                            <video v-if="item.indexOf('mp4') != -1" controls :src="item" width="579px" height="326px">
                                <!-- <source :src="item" type="video/mp4"> -->
                            </video>
                            <img v-else :src="item"/>
                        </div>
                    </div>
                    <!-- Add Arrows -->
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
                <div class="swiper-container gallery-thumbs">
                    <div class="swiper-wrapper">
                         <!-- :style="{ backgroundImage:'url('+newproductList[0]+')'}" -->
                        <div class="swiper-slide" v-for="(item,index) in dataFrom.picsArr" :key="index" :style="{backgroundImage:'url('+item+')'}">
                            <video v-if="item.indexOf('mp4') != -1" controls width="145px" height="82px">
                                <source :src="item" type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="specifications">
            <div class="title">
                    <p>产品参数</p>
                    <p>Specifications</p>
            </div>
            <div class="rich_text">
                <div class="text_left">
                    <span>{{languageType == 0?'产品名称：':'Product Name：'}}{{languageType == 0?dataFrom.name:dataFrom.enName}}</span>
                    <span>{{languageType == 0?'产品系列：':'Product line：'}}{{languageType == 0?dataFrom.type:dataFrom.enType}}</span>
                </div>
                <div class="text_middle">
                    <span>{{languageType == 0?'产品尺寸：':'Product Size：'}}{{languageType == 0?dataFrom.size:dataFrom.enSize}}</span>
                    <span>{{languageType == 0?'屏幕尺寸：':'Screen size：'}}{{languageType == 0?dataFrom.screen:dataFrom.enScreen}}</span>
                </div>
                <div class="text_right">
                    <span>{{languageType == 0?'电源功率：':'Power supply：'}}{{dataFrom.power}}</span>
                    <span>{{languageType == 0?'产品净重：':'Net weight：'}}{{dataFrom.weight}}</span>
                </div>
            </div>
        </div>
        <div class="introduction">
            <div class="title">
                    <p>产品详情</p>
                    <p>Product Introduction</p>
            </div>
            <div class="pictures">
                <ul>
                    <li v-for="(item,index) in dataFrom.picArr" :key="index">
                        <img :src="item" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            dataFrom:{}
        }
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getDataList(JSON.parse(this.$route.query.key))
            }
        }

    },
    created () {
        const key= JSON.parse(this.$route.query.key) 
        this.getDataList(key)
        if(!this.$route.query.id) return
        const id = JSON.parse(this.$route.query.id)
        this.$emit('changeIndex',id)
    },
    mounted () {
        setTimeout(function(){
            var galleryThumbs = new Swiper('.gallery-thumbs', {
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            var galleryTop = new Swiper('.gallery-top', {
                spaceBetween: 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs
                }
            });
        },200)
        
    },
    methods:{
        getDataList (key) {
            this.$http({
                url: this.$http.adornUrl('/web/productDetail/list'),
                method: 'post',
                data: {
                    'page': 1,
                    'limit':10,
                    'key':key
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    data.page.list.forEach(item => {
                        // console.log(item);
                        item['picsArr'] = this.languageType == 0?item.pics.split(','):item.enPics == ''?item.pics.split(','):item.enPics.split(',')
                        item['picArr'] = this.languageType == 0?item.specification.split(','):item.enSpecification == ''?item.specification.split(','):item.enSpecification.split(',')
                    })
                    this.dataFrom = data.page.list[0]
                } else {
                    this.dataList = []
                }
            })
        },
        goTB (url) {
            window.open(url,"_blank")
        },
        changeDetail (id,name) {
            this.getDataList(name)
        }
    },
}
</script>

<style lang="less" scoped>
    .productdetail {
        width: 1220px;
        background-color: #ffffff;
        margin: 0 auto;
        margin-top: 20px;
        position: relative;
        z-index: 100;
        padding-bottom: 90px;
        margin-bottom: 90px;
        .name {
            margin: 0px 80px 30px 80px;
            border-bottom: 1px solid #e21711;
            padding-top: 25px;
            overflow: hidden;
            .product_name {
                float: left;
                span {
                    display: block;
                    font-size: 42px;
                    color: #ffffff;
                    padding: 15px 20px;
                     background-color: #e21711;
                }
            }
            .product_links {
                float: right;
                width: 117px;
                height: 43px;
                background-color: #e21711;
                overflow: hidden;
                border-radius: 5px;
                margin-top: 16px;
                cursor: pointer;
                p {
                    text-align: center;
                    float: left;
                    font-size: 16px;
                    color: #ffffff;
                    height: 43px;
                    width: 84px;
                    line-height: 43px;
                    border-right: 1px solid #ad0c07;
                }
                .arrow {
                    float: left;
                    width: 32px;
                    height: 43px;
                    line-height: 43px;
                    color: #ffffff;
                }
            }
        }
        .detail {
            margin: 0 80px;
            padding-bottom: 80px;
            overflow: hidden;
            border-bottom: 2px solid #aeaeae;
            .text {
                float: left;
                width: 361px;
                height: 419px;
                text-align: left;
                .ql-align-center {
                    text-align: center;
                }
                p {
                    text-align: left;
                }
            }
            .whell {
                float: left;
                margin-left: 70px;
                width: 579px;
                height: 419px;
                .swiper-container {
                    width: 100%;
                    height: 419px;
                    margin-left: auto;
                    margin-right: auto;
                    .swiper-slide {
                        background-size: cover;
                        background-position: center;
                    }
                    .swiper-button-prev:after {
                        color: #e21711;
                    
                    }
                    .swiper-button-next:after {
                        color: #e21711;
                    }
                    &.gallery-top {
                        height: 326px;
                        width: 100%;
                        .swiper-slide {
                            width: 579px;
                            height: 326px;
                        }
                    }
                    &.gallery-thumbs {
                        height: 83px;
                        box-sizing: border-box;
                        padding: 10px 0;
                    }
                    &.gallery-thumbs .swiper-slide {
                        width:145px;
                        height: 82px;
                        opacity: 0.4;
                    }
                    &.gallery-thumbs .swiper-slide-thumb-active {
                        opacity: 1;
                    }
                }
            }
        }
        .specifications {
            margin: 0 80px;
            .title {
                    margin: 0 auto;
                    position: relative;
                    margin-top: 50px;
                    margin-bottom: 50px;
                    p{
                        color: #e21711;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 6px;
                    }
            }
            .title::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        left: 277px;
                        background-color: #e21711;
            }
            .title::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        right: 277px;
                        background-color: #e21711;
            }
            .rich_text {
                border-bottom: 2px solid #aeaeae;
                padding-bottom:50px;
                overflow: hidden;
                span {
                    font-size: 15px;
                    color: #606060;
                    display:block;
                }
                .text_left {
                    float: left;
                    min-width: 270px;
                    padding-left: 15px;
                    text-align: left;
                    span {
                        &:last-child {
                            margin-top: 25px;
                        }
                    }
                }
                .text_middle {
                    float: left;
                    max-width: 550px;
                    text-align: left;
                    span {
                        &:last-child {
                            margin-top: 25px;
                        }
                    }
                }
                .text_right {
                    float: right;
                    text-align: left;
                    padding-right: 15px;
                    span {
                        &:last-child {
                            margin-top: 25px;
                        }
                    }
                    
                }
            }
        }
        .introduction {
            .title {
                    margin: 0 80px;
                    position: relative;
                    margin-top: 50px;
                    margin-bottom: 30px;
                    p{
                        color: #e21711;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 6px;
                    }
            }
            .title::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        left: 277px;
                        background-color: #e21711;
            }
            .title::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        right: 277px;
                        background-color: #e21711;
            }
            .pictures {
                width: 1105px;
                margin: 0 auto;
                ul {
                    li {
                        width: 1105px;
                        text-align: center;
                        // height: 622px;
                        // background-size: cover;
                        // background-position: center;
                        img {
                            width: auto;
                            object-fit:contain;
                            border: 0;
                            display: block;
                            margin: 0 auto;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/productdetail.vue